import { render, staticRenderFns } from "./PartnerAccountList.vue?vue&type=template&id=673dd867&"
import script from "./PartnerAccountList.vue?vue&type=script&lang=js&"
export * from "./PartnerAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports